<script lang="ts">
import { defineComponent, PropType, toRef } from 'vue'
import StepWrapper from './StepWrapper.vue'
import userCareer from '@/models/userCareer'

export default defineComponent({
  name: 'ProfessionDomainStep',

  components: {
    StepWrapper,
  },

  props: {
    namespace: {
      type: String,
      required: true,
    },

    profession: {
      type: Object as PropType<InputText>,
      required: true,
    },

    professionDomain: {
      type: Object as PropType<InputMultiSelect>,
      required: true,
    },
  },

  emits: ['update:professionDomain', 'click:prev', 'click:next'],

  setup(props) {
    const { PROFESSION_DOMAINS } = userCareer(toRef({ profession: props.profession }))

    return {
      // constants
      PROFESSION_DOMAINS,
    }
  },
})
</script>

<template>
  <StepWrapper
    :namespace="namespace"
    :input-scheme="professionDomain"
    category-label="担当領域"
    :category-items="PROFESSION_DOMAINS[profession.value] || []"
    @update:model-value="$emit('update:professionDomain', $event)"
    @click:prev="$emit('click:prev')"
    @click:next="$emit('click:next')" />
</template>
